import { downloadCsv, toCsvRow } from '../../../utils/downloadCsv';
import { getGymExportBrand, getGymExportSlug } from '../../../utils/gymExportBrand';
import { getExportTimestamp } from '../../../utils/professionalExport';

const date = () => new Date().toISOString().slice(0, 10);

function gymReportHeader() {
  const brand = getGymExportBrand();
  return [
    brand.name,
    brand.branch,
    brand.address,
    `${brand.phone} · ${brand.email}`,
    `Generated: ${getExportTimestamp()}`,
    '',
  ].join('\n');
}

function buildAllReportsCsv(reports) {
  const {
    memberReport = [],
    attendanceReport = [],
    revenueReport = [],
    membershipReport = [],
    trainerReport = [],
    profitReport = [],
    branchReport = [],
  } = reports;

  const sections = [
    ['Member Report', ['Status', 'Count', 'New This Month', 'Churned'], memberReport.map((r) => [r.status, r.count, r.newThisMonth, r.churned])],
    ['Attendance Report', ['Branch', 'Check-ins', 'Avg Daily', 'Percentage'], attendanceReport.map((r) => [r.branch, r.checkIns, r.avgDaily, `${r.percentage}%`])],
    ['Revenue Report', ['Month', 'Memberships', 'Other', 'Total'], revenueReport.map((r) => [r.month, r.memberships, r.other, r.total])],
    ['Membership Report', ['Package', 'Active', 'Renewals', 'Revenue'], membershipReport.map((r) => [r.package, r.active, r.renewals, r.revenue])],
    ['Trainer Report', ['Trainer', 'Members', 'Sessions', 'Rating'], trainerReport.map((r) => [r.trainer, r.members, r.sessions, r.rating])],
    ['Profit Report', ['Month', 'Revenue', 'Expenses', 'Salaries', 'Profit'], profitReport.map((r) => [r.month, r.revenue, r.expenses, r.salaries, r.profit])],
    ['Branch Report', ['Branch', 'Members', 'Revenue', 'Attendance %', 'Trainers'], branchReport.map((r) => [r.branch, r.members, r.revenue, `${r.attendance}%`, r.trainers])],
  ];

  return `${gymReportHeader()}${sections.flatMap(([title, headers, rows], i) => {
    const block = [title, toCsvRow(headers), ...rows.map((row) => toCsvRow(row))];
    return i < sections.length - 1 ? [...block, ''] : block;
  }).join('\n')}`;
}

export function exportCsv(reports) {
  downloadCsv(buildAllReportsCsv(reports), `gym-reports-${getGymExportSlug()}-${date()}.csv`);
}

export function exportExcel(reports) {
  downloadCsv(buildAllReportsCsv(reports), `gym-reports-${getGymExportSlug()}-${date()}.xls`);
}

function openReportsWindow(reports, autoPrint) {
  const content = buildAllReportsCsv(reports);
  const blob = new Blob([content], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const win = window.open(url, '_blank');
  if (win) {
    if (autoPrint) {
      win.onload = () => {
        win.print();
        window.setTimeout(() => URL.revokeObjectURL(url), 1000);
      };
    } else {
      window.setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
  } else {
    URL.revokeObjectURL(url);
  }
}

export function exportPdf(reports) {
  openReportsWindow(reports, false);
}

export function printReports(reports) {
  openReportsWindow(reports, true);
}

export function exportReportSection(title, headers, rows, slug) {
  const brand = getGymExportBrand();
  const lines = [
    brand.name,
    title,
    toCsvRow(headers),
    ...rows.map((row) => toCsvRow(row)),
  ];
  downloadCsv(lines.join('\n'), `${slug}-${getGymExportSlug()}-${date()}.csv`);
}
